import { useEffect, useState } from "react";
import FeedbackModule from "@/components/FeedbackModule";
import { fetchProducts, api } from "@/lib/api";

const CUSTOMER_MODULES = [
    {
        key: "share_your_ritual",
        label: "Your Ritual",
        fields: ["name", "email", "title", "rating", "body"],
        placeholder: "Tell us about your bath ritual…",
    },
    {
        key: "product_recommendation",
        label: "Recommend a Bar",
        fields: ["name", "email", "product_slug", "title", "body"],
        placeholder: "What should we make next? Scent, ingredient, mood…",
    },
    {
        key: "video_testimonial",
        label: "Video Testimonial",
        fields: ["name", "email", "media_url", "title", "body"],
        placeholder: "Share a TikTok / Instagram reel link and a one-line caption.",
    },
];

export default function ShareYourRitual() {
    const [products, setProducts] = useState([]);
    const [copy, setCopy] = useState({ intro: "", confirmation: "" });
    useEffect(() => {
        fetchProducts().then(setProducts).catch(() => setProducts([]));
        api.get("/public/studio-form").then(({ data }) => setCopy(data)).catch(() => {});
    }, []);

    return (
        <div data-testid="share-your-ritual">
            <FeedbackModule
                channel="customer"
                kicker="Share Your Ritual"
                title="Tell the studio."
                helper={copy.intro}
                successTitle="Mahalo."
                successText={copy.confirmation}
                hideTag
                modules={CUSTOMER_MODULES}
                products={products}
                testIdPrefix="customer-feedback"
                palette={{
                    bg: "transparent",
                    ink: "#1a1206",
                    accent: "#3d2a0c",
                    buttonInk: "#fdf3dc",
                    panel: "rgba(255,248,230,0.22)",
                }}
            />
        </div>
    );
}
